/**
 * @enum PlaylistStatusV2
 * @description The possible statuses of a challenge
 */
enum PlaylistStatusV2 {
  NOT_STARTED = "NOT_STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

export default PlaylistStatusV2;
